import { EGerdauService } from '../EGerdauService';
import { IFabricationPurchaseOrderState } from '../../store/ducks/fabrication-purchase-order/types';
import {
  customersAuthorizationApi,
  ECustomerAuthorizationEndpoints
} from '../api';
import { EPieceTypes, IDiameter } from '../../store/ducks/fabrication/types';

export class FabricationPurchaseOrderService extends EGerdauService {
  async sendFabricationPurchaseOrder(
    fabricationPurchaseOrderState: IFabricationPurchaseOrderState
  ): Promise<number> {
    const headers = super.getHeaders();

    const { constructionIdentification, detailingProject, extraItens } =
      fabricationPurchaseOrderState;

    const bodyRequest = {
      contractNumber: constructionIdentification.contractNumber,
      orderNumber: constructionIdentification.orderNumber,
      desiredDate: constructionIdentification.desiredDate,
      tower: constructionIdentification.towers?.join(', '),
      isSingleTower: constructionIdentification.isSingleTower,
      logisticObservation: constructionIdentification.observation,

      productType: detailingProject.productType,
      vehicleType: detailingProject.vehiclesTypes,

      observation: detailingProject.observation,
      itens: detailingProject.itens
        .filter((projectItem) => projectItem.projectId)
        .map((projectItem) => {
          return {
            projectId: projectItem.projectId,
            pavement: projectItem.pavement,
            pavements: projectItem.pavements.map((p) => p.id),
            revision: projectItem.revision,
            amount: projectItem.amount,
            completeDrawing: projectItem.completeDrawing,
            observation: projectItem.observation
          };
        }),

      otherPieces: extraItens.otherPieces
        .filter((extraItem) => extraItem.pieceTypeId)
        .map((extraItem) => {
          return {
            pieceTypeId: extraItem.pieceTypeId,
            steelTypeId: extraItem.steelTypeId,
            diameterId: extraItem.diameterId,
            measureA: extraItem.measureA,
            measureB: extraItem.measureB,
            measureC: extraItem.measureC,
            amount: extraItem.amount,
            weight: extraItem.weight
          };
        }),

      annealedWires: extraItens.annealedWires
        .filter((wireType) => wireType.annealedWireTypeId)
        .map((wireType) => {
          return {
            annealedWireTypeId: wireType.annealedWireTypeId,
            ...(wireType.percentage && { percentage: wireType.percentage }),
            ...(wireType.weight && { weight: wireType.weight })
          };
        })
    };

    const response = await customersAuthorizationApi.post(
      `${ECustomerAuthorizationEndpoints.FABRICATION_ORDER_ENTRY}`,
      bodyRequest,
      { headers }
    );

    const createdId: number = response.data.id;

    return createdId;
  }

  static calculateExtraItemWeight(
    pieceTypeId: EPieceTypes,
    amount: number,
    diameter: IDiameter,
    measureA: number,
    measureB: number,
    measureC: number
  ): number {
    let weigth = 0;
    switch (pieceTypeId) {
      case EPieceTypes.Barra:
        weigth = (measureA * amount * diameter.ml) / 100;
        break;

      case EPieceTypes.Estribo:
        // eslint-disable-next-line no-case-declarations
        const aux =
          measureB < diameter.stirrupBend ? measureB : diameter.stirrupBend;
        weigth =
          ((2 * measureA + 2 * measureB + 2 * aux) * diameter.ml * amount) /
          100;
        break;

      case EPieceTypes.FerroL:
        weigth = ((measureA + measureB) * diameter.ml * amount) / 100;
        break;

      case EPieceTypes.Caranguejo:
      case EPieceTypes.Bandeja:
        weigth =
          ((2 * measureA + 2 * measureB + measureC) * diameter.ml * amount) /
          100;
        break;

      case EPieceTypes.FerroU:
        weigth =
          ((measureA + measureB + measureC) * diameter.ml * amount) / 100;
        break;

      case EPieceTypes.Espiral:
        weigth =
          (((Math.PI * measureA * measureC) / measureB) *
            diameter.ml *
            amount) /
          100;
        break;

      case EPieceTypes.Circular:
        weigth =
          ((Math.PI * measureA + 2 * diameter.circularFold) *
            diameter.ml *
            amount) /
          100;
        break;

      case EPieceTypes.CTransp:
        weigth = ((Math.PI * measureA + measureB) * diameter.ml * amount) / 100;
        break;

      case EPieceTypes.CGancho:
        weigth =
          ((Math.PI * measureA + measureB + 2 * diameter.circularFold) *
            diameter.ml *
            amount) /
          100;
        break;
    }

    return Math.round(weigth);
  }

  static async downloadPurchaseOrderPDF(orderId: number): Promise<string> {
    const headers = new EGerdauService().getHeaders();
    const response = await customersAuthorizationApi.get(
      `${ECustomerAuthorizationEndpoints.FABRICATION_ORDER_PDF_DOWNLOAD.replace(
        ':id',
        orderId.toString()
      )}`,
      { headers }
    );
    const orderPdfInBase64 = response.data as string;
    return orderPdfInBase64;
  }
}
